import { actionCreator } from '@ardoq/rxbeach';
import { QueryBuilderQuery } from '@ardoq/api-types';

export type SetCanvasSidebarQueryPayload = {
  query: QueryBuilderQuery | null;
};

export const setCanvasSidebarQuery =
  actionCreator<SetCanvasSidebarQueryPayload>('[canvasSidebar] SET_QUERY');
